var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShield(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 101 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "seguro-de-salud 1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M76.9917 10.8722C57.7834 11.2305 44.4028 1.52497 35.1473 1.69997C25.8917 1.87497 6.54727 7.5583 7.34449 50.1444C8.14171 92.7305 34.4112 98.4889 44.5945 98.3C92.2695 97.4083 111.014 10.2361 76.9917 10.8722Z",
    fill: "#FBE2E8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M50.8333 81.9444C50.8333 81.9444 77.2222 75 77.2222 50.4972C77.2222 36.8055 77.2222 27.7778 77.2222 27.7778L50.8333 18.0555L24.4445 27.7778V50.4972C24.4445 75 50.8333 81.9444 50.8333 81.9444Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M49.4445 34.7222H52.2223C53.7556 34.7222 55 35.9666 55 37.4999V45.8333H63.3334C64.8667 45.8333 66.1112 47.0777 66.1112 48.6111V51.3888C66.1112 52.9222 64.8667 54.1666 63.3334 54.1666H55V62.4999C55 64.0333 53.7556 65.2777 52.2223 65.2777H49.4445C47.9112 65.2777 46.6667 64.0333 46.6667 62.4999V54.1666H38.3334C36.8 54.1666 35.5556 52.9222 35.5556 51.3888V48.6111C35.5556 47.0777 36.8 45.8333 38.3334 45.8333H46.6667V37.4999C46.6667 35.9666 47.9112 34.7222 49.4445 34.7222Z",
    fill: "#D586B0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M53.6111 81C51.9167 81.6666 50.8333 81.9444 50.8333 81.9444C50.8333 81.9444 24.4445 75 24.4445 50.5C24.4445 36.8055 24.4445 27.7778 24.4445 27.7778L50.8333 18.0555L53.6111 19.0833L30 27.7778V50.5C30 70.0833 46.8333 78.4444 53.6111 81Z",
    fill: "#FBE2E8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M43.8889 54.1667H38.3334C36.8056 54.1667 35.5556 52.9167 35.5556 51.3889V48.6112C35.5556 47.0834 36.8056 45.8334 38.3334 45.8334H43.8889C42.3612 45.8334 41.1112 47.0834 41.1112 48.6112V51.3889C41.1112 52.9167 42.3612 54.1667 43.8889 54.1667Z",
    fill: "#9F4487"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M50.8334 84.0278C50.6556 84.0278 50.4778 84.0056 50.3028 83.9583C50.0223 83.8861 22.3611 76.3083 22.3611 50.4972V27.7778C22.3611 26.9055 22.9056 26.125 23.725 25.8222L50.1139 16.1C50.5778 15.9278 51.0917 15.9278 51.5556 16.1L77.9445 25.8222C78.7611 26.125 79.3056 26.9055 79.3056 27.7778V50.4972C79.3056 76.3083 51.6445 83.8861 51.3639 83.9583C51.1889 84.0056 51.0111 84.0278 50.8334 84.0278ZM26.5278 29.2305V50.4972C26.5278 71.4917 47.1334 78.6611 50.8334 79.7778C54.5334 78.6611 75.1389 71.4917 75.1389 50.4972V29.2305L50.8334 20.275L26.5278 29.2305Z",
    fill: "#571259"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M52.2223 67.3611H49.4445C46.764 67.3611 44.5834 65.1806 44.5834 62.5V56.25H38.3334C35.6528 56.25 33.4723 54.0695 33.4723 51.3889V48.6111C33.4723 45.9306 35.6528 43.75 38.3334 43.75H44.5834V37.5C44.5834 34.8195 46.764 32.6389 49.4445 32.6389H52.2223C54.9028 32.6389 57.0834 34.8195 57.0834 37.5V43.75H63.3334C66.014 43.75 68.1945 45.9306 68.1945 48.6111V51.3889C68.1945 54.0695 66.014 56.25 63.3334 56.25H57.0834V62.5C57.0834 65.1806 54.9028 67.3611 52.2223 67.3611ZM38.3334 47.9167C37.9501 47.9167 37.639 48.2278 37.639 48.6111V51.3889C37.639 51.7722 37.9501 52.0834 38.3334 52.0834H46.6667C47.8167 52.0834 48.7501 53.0167 48.7501 54.1667V62.5C48.7501 62.8834 49.0612 63.1945 49.4445 63.1945H52.2223C52.6056 63.1945 52.9167 62.8834 52.9167 62.5V54.1667C52.9167 53.0167 53.8501 52.0834 55.0001 52.0834H63.3334C63.7167 52.0834 64.0278 51.7722 64.0278 51.3889V48.6111C64.0278 48.2278 63.7167 47.9167 63.3334 47.9167H55.0001C53.8501 47.9167 52.9167 46.9834 52.9167 45.8334V37.5C52.9167 37.1167 52.6056 36.8056 52.2223 36.8056H49.4445C49.0612 36.8056 48.7501 37.1167 48.7501 37.5V45.8334C48.7501 46.9834 47.8167 47.9167 46.6667 47.9167H38.3334Z",
    fill: "#571259"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M28.2735 8.74512L32.2019 4.81675L34.1661 6.78093L30.2377 10.7093L28.2735 8.74512Z",
    fill: "#D586B0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    d: "M16.9791 20.0377L20.9074 16.1093L22.8716 18.0735L18.9433 22.0019L16.9791 20.0377Z",
    fill: "#D586B0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_10",
    d: "M16.9796 6.28833L18.9438 4.32414L22.8722 8.25252L20.908 10.2167L16.9796 6.28833Z",
    fill: "#D586B0"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShield);
export default __webpack_public_path__ + "static/media/shield.6c7e83fdce13813b2b71c9eb64d773a0.svg";
export { ForwardRef as ReactComponent };